/**
 * @ngdoc service
 * @name Ecourses
 * @description Service to get the ecourse data.
 * @param environment
 * @param $http
 * @param $q
 * @returns {{get: get, syncProgress: syncProgress, register: register, bookmark: bookmark}}
 * @constructor
 */
export default function Ecourses(environment, $http, $q) {
  'ngInject';

  const REGISTRATION_TYPES = [
      'purchase',
      'gift',
      'redeem'
    ],
    ERRORS = {
      registrationArguments: "Something went wrong with the registration please reload the page.",
      registrationServer: "There was an unknown error on www.bethel.tv; we have been notified. Please try your registration again."
    };

  /**
   * @name Get
   * @description Get an ecourse by slug
   * @param id
   */
  function get(slug) {
    let defer = $q.defer(),

      params = {
        method: 'GET',
        url: `${environment.api.baseUrl}/ecourses/${slug}`,
      },

      req = $http(params),

      success = (response) => {
        return defer.resolve(response.data.ecourse);
      },

    //Handle Errors, 404, ect...
      error = (response) => {
        return defer.reject(response.status);
      };

    req.then(success, error);

    return defer.promise;
  }

  /**
   * @description toggle bookmark status of the ecourse.
   * @param slug
   * @returns {*} Status of the bookmark.
   */
  function bookmark(ecourse){
    let defer = $q.defer(),

      params = {
        method: 'POST',
        url: `${environment.api.baseUrl}/ecourses/${ecourse.slug}/bookmark`,
        headers: { 'Content-Type': 'text/plain' },
      },

      req = $http(params),

      success = (response) => {
        if(response.data) {
          ecourse.bookmark = response.data.bookmark;
          return defer.resolve(response.data);
        }
      },

      error = () => {
        return defer.reject();
      };

    req.then(success, error);

    return defer.promise;
  }

  /**
   * @name syncProgress
   * @description Posts the local progress data to the server for synchronization.
   * @param progressData
   * @param reset
   * @return {*}
   */
  function syncProgress(progressData, reset = false) {
    let defer = $q.defer(),

      params = {
        method: 'POST',
        url: `${environment.api.baseUrl}/ecourses/${progressData.slug}/progress`,
        headers: { 'Content-Type': 'text/plain' },
        data: {
          reset,
          progress: progressData.userData.progress
        }
      },

      req = $http(params),

      success = () => {
        return defer.resolve();
      },

    //Handle Errors
      error = (response) => {
        return defer.reject(response.status);
      };

    req.then(success, error);

    return defer.promise;
  }

  /**
   * @name register
   * @description This method takes the endpoint and the formdata to send registration data to the server. It returns a promise. Any successfule resolution is treated as a complete success. Any error will reject the promise and send corresponding errors(if provided) back to the caller.
   * @params registrationType The registration type, validated.
   * @params formData The POJO with all the data for the registration. This data is assumed to be pre-validated.
   * @return {Promise}
   */
  
  function register(registrationType, ecourse ,formData) {
    //Ensure registrationType is in the Types array
    let regTypeValid = REGISTRATION_TYPES.find(elem => registrationType === elem);
    //Combines all invalid states to reject.
    if (!registrationType || !ecourse || !regTypeValid || !formData) {
      return $q.reject({
        alert: ERRORS.registrationArguments
      });
    }
    let params = {
        method: 'POST',
        url: `${environment.api.baseUrl}/ecourses/${ecourse.slug}/${registrationType}`,
        data: formData,
        headers: { 'Content-Type': 'text/plain' }
      },

      defer = $q.defer(),

      req = $http(params),

      success = (response) => {
        let data = response.data && typeof response.data === 'object' ? response.data : undefined;
        if(data) {
          if (data.errors) {
            defer.reject(data);
          }
          defer.resolve(data);
        }
      },

      error = (response)=> {
        let errors = {};
        if (response.status === 500) {
          errors.alert = ERRORS.registrationServer;
        }
        defer.reject(errors);
      };

    req.then(success, error);
    return defer.promise;
  }

  function getCurrentVideo(id, isOverview) {
    let defer = $q.defer();
    let url;
    if (isOverview) {
      url = `${environment.api.baseUrl}/ecourse_contents/promo_video_url/${id}`
    } else {
      url = `${environment.api.baseUrl}/ecourse_contents/video_url/${id}`
    }
    let params = {
      method: 'GET',
      url: url,
    }
    let req = $http(params),
    success = (response) => {
      return defer.resolve(response.data);
    },
    //Handle Errors, 404, ect...
    error = (response) => {
      return defer.reject(response.status);
    };
  
    req.then(success, error);
    return defer.promise;
  }
  


  return {
    get,
    syncProgress,
    register,
    bookmark,
    getCurrentVideo
  };
}



/** WEBPACK FOOTER **
 ** ./src/app/services/ecourse/ecourses.factory.js
 **/